// components/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api, { setToken } from '../api';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const navigate                = useNavigate();
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const { data } = await api.post('/auth/login', { email, password });
      // 1) persist the JWT
      localStorage.setItem('token', data.token);
      localStorage.setItem('email', data.user.email);
      // 2) set default header for future calls
      setToken(data.token);
      // 3) redirect to profile
      navigate('/profile', { replace: true });
    } catch (err) {
      console.error('Login failed:', err);
      setError(err.response?.data?.message || 'Login failed');
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto -mt-12 p-6 bg-gray-800 rounded-lg shadow-lg font-mono">
      <h2 className="text-2xl font-bold mb-4 text-white text-center">Log In</h2>
      {error && <div className="mb-4 text-red-400 text-sm">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className="w-full px-3 py-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-violet-500"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          className="w-full px-3 py-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-violet-500"
        />
        
        {/* Forgot Password Link */}
        <div className="text-right">
          <Link to="/forgot-password" className="text-sm text-violet-400 hover:text-violet-300">
            Forgot your password?
          </Link>
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 bg-gradient-to-r from-violet-500 to-pink-500 rounded text-white font-semibold hover:from-violet-600 hover:to-pink-600 transition relative"
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
              <span>Logging in...</span>
            </div>
          ) : (
            'Log In'
          )}
        </button>
      </form>
      <p className="mt-4 text-sm text-gray-400 text-center">
        Need an account?{' '}
        <Link to="/signup" className="text-violet-400 hover:text-violet-200">
          Sign Up
        </Link>
      </p>
    </div>
  );
}
